export default __webpack_public_path__ + "static/before-c1c94c729b13de0c4099107abbb2baff.png";